let retry = [];
const RETRY_FUNC_TIMEOUT = process.env.RETRY_FUNC_TIMEOUT || 4000;

export function safeCall(name, cb, args = undefined) {
    try {
        if (cb) cb(args);
    } catch (e) {
        console.error(name, e);
    }
}

export const retryReset = (key) => {
    retry[key] = 0;
}

export const retryFunc = (key, func, onError, timeout = RETRY_FUNC_TIMEOUT) => {
    if (!retry[key]) {
        retry[key] = 0;
    }

    if (retry[key]++ > 4) {
        console.error('failed to execute ', key, 'after', 4, 'times');
        onError && onError();
    } else {
        setTimeout(func, timeout);
    }
}

